<template>
  <div class="curso-main-container pb-3">
    <BannerInterno></BannerInterno>
    <div class="container tarjeta tarjeta--blanca p-4 p-md-5 mb-5">
      <div class="titulo-principal color-acento-contenido">
        <div class="titulo-principal__numero"><span>4</span></div>
        <h1>Gestión de variabilidad espacial y temporal</h1>
      </div>
      <div class="row justify-content-center mb-4">
        <div class="col-lg-4 my-lg-0 my-3">
          <img class="img-a img-t" src="@/assets/curso/temas/75.png" alt="" />
        </div>
        <div class="col-lg-8 my-lg-0 my-3">
          <div
            class="row justify-content-center align-items-center bg3 p-4 brad mb-4"
          >
            <div class="col-lg-auto">
              <img
                class="img-a img-t"
                src="@/assets/curso/temas/76.png"
                alt=""
              />
            </div>
            <div class="col pt-lg-0 pt-md-4">
              <p class="mb-0">
                En los sistemas productivos agropecuarios, la variabilidad
                espacial y temporal es un factor clave que influye en la
                productividad y eficiencia de los cultivos y la producción
                pecuaria. La variabilidad espacial se refiere a las diferencias
                que existen en las condiciones del suelo, el agua y otros
                recursos dentro de una misma parcela o entre parcelas cercanas.
                Por otro lado, la variabilidad temporal abarca los cambios que
                ocurren a lo largo del tiempo, como las fluctuaciones
                estacionales en el clima o la evolución de las propiedades del
                suelo debido a prácticas agrícolas.
              </p>
            </div>
          </div>
        </div>
      </div>
      <p>
        Gestionar esta variabilidad es fundamental para optimizar la producción,
        ya que permite adaptar las prácticas agrícolas a las condiciones
        específicas de cada área y momento. Esto es posible gracias a
        herramientas avanzadas, como los sistemas de información geográfica
        (SIG), sensores IoT y drones, que facilitan la recopilación y análisis
        de datos georreferenciados. La integración de estas tecnologías en el
        manejo agrícola permite implementar estrategias de agricultura de
        precisión, como la fertilización y el riego variable, que aseguran un
        uso eficiente de los recursos y mejoran el rendimiento del sistema
        productivo.
      </p>
      <Separador> </Separador>
      <div
        id="t_4_1"
        class="titulo-segundo color-acento-contenido"
        data-aos="zoom-in-left"
      >
        <h2>4.1 variabilidad espacial y temporal en la agricultura</h2>
      </div>
      <div class="row justify-content-center mb-4">
        <div class="col-lg-7 my-lg-0 my-3">
          <div class="bg3 p-4 brad mb-4">
            <p class="mb-0">
              La variabilidad espacial y temporal es una característica
              inherente a los sistemas productivos agropecuarios. Se refiere a
              las diferencias en las condiciones del suelo, el clima, y el
              estado de los cultivos o animales a lo largo del tiempo y el
              espacio. Esta variabilidad puede tener un impacto significativo en
              la productividad, la eficiencia en el uso de recursos y la
              sostenibilidad del sistema productivo.
            </p>
          </div>
          <p>
            La variabilidad espacial considera cómo cambian las condiciones
            dentro de una misma parcela o entre diferentes parcelas de un mismo
            sistema. Por otro lado, la variabilidad temporal se refiere a cómo
            varían las condiciones a lo largo del tiempo debido a factores como
            el clima, las prácticas de manejo y las dinámicas del ecosistema.
          </p>
        </div>
        <div class="col-lg-5 my-lg-0 my-3">
          <img class="img-a img-t" src="@/assets/curso/temas/77.png" alt="" />
        </div>
      </div>
      <div
        class="row justify-content-center align-items-center bg2 p-4 brad mb-4"
      >
        <div class="col-lg-auto">
          <img class="img-a img-t" src="@/assets/curso/temas/78.png" alt="" />
        </div>
        <div class="col pt-lg-0 pt-md-4">
          <p class="mb-0">
            La gestión adecuada de esta variabilidad, a través de tecnologías
            avanzadas y prácticas de agricultura de precisión, permite optimizar
            las operaciones, mejorar el rendimiento y reducir los impactos
            ambientales.
          </p>
        </div>
      </div>
      <Separador> </Separador>
      <div
        id="t_4_2"
        class="titulo-segundo color-acento-contenido"
        data-aos="zoom-in-left"
      >
        <h2>4.2 variabilidad espacial y temporal en la agricultura</h2>
      </div>
      <div class="row justify-content-center mb-4">
        <div class="col-lg-5 my-lg-0 my-3">
          <img class="img-a img-t" src="@/assets/curso/temas/79.png" alt="" />
        </div>
        <div class="col-lg-7 my-lg-0 my-3">
          <p>
            La variabilidad espacial se manifiesta en diferencias en
            características del suelo, como la textura, el contenido de materia
            orgánica, la capacidad de retención de agua y la fertilidad. Estas
            diferencias influyen en cómo los cultivos responden a las prácticas
            de manejo, como la fertilización y el riego.
          </p>
          <p>
            Por otro lado, la variabilidad temporal afecta el sistema productivo
            debido a cambios estacionales o interanuales en las condiciones
            climáticas, como la temperatura, la precipitación y la humedad.
            Además, la variabilidad temporal puede estar relacionada con eventos
            extremos, como sequías o inundaciones.
          </p>
        </div>
      </div>
      <div class="row bg8 align-items-center">
        <div class="col-lg-12 col-12 px-lg-5 px-4">
          <div class="row justify-content-center align-items-center">
            <div class="col-lg-12">
              <div class="bgw brad p-5 my-5">
                <CarouselRED tipo="b">
                  <div class="row justify-content-center">
                    <div class="col-lg-6 my-2">
                      <h5 class="mb-4">Variabilidad espacial</h5>
                      <p>
                        Se refiere a las diferencias en las propiedades físicas,
                        químicas y biológicas del suelo, así como en las
                        condiciones micro climáticas dentro de una misma parcela
                        o entre parcelas vecinas.
                      </p>
                    </div>
                    <div class="col-lg-5 my-2">
                      <img
                        class="img-a img-t"
                        src="@/assets/curso/temas/80.png"
                        alt=""
                      />
                    </div>
                  </div>
                  <div class="row justify-content-center">
                    <div class="col-lg-6 my-2">
                      <h5 class="mb-4">Variabilidad temporal</h5>
                      <p>
                        Incluye cambios estacionales y anuales en variables como
                        la temperatura, la precipitación y la disponibilidad de
                        agua en el suelo, influenciados por fenómenos climáticos
                        y prácticas de manejo.
                      </p>
                    </div>
                    <div class="col-lg-5 my-2">
                      <img
                        class="img-a img-t"
                        src="@/assets/curso/temas/81.png"
                        alt=""
                      />
                    </div>
                  </div>
                </CarouselRED>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Separador> </Separador>
      <div
        id="t_4_3"
        class="titulo-segundo color-acento-contenido"
        data-aos="zoom-in-left"
      >
        <h2>
          4.3 Impacto de la variabilidad espacial y temporal en los sistemas
          productivos
        </h2>
      </div>
      <p>
        La variabilidad espacial y temporal puede generar desigualdades en el
        rendimiento de los cultivos y en la eficiencia del uso de insumos. Por
        ejemplo, algunas áreas dentro de una parcela pueden ser más fértiles y
        requerir menos fertilización, mientras que otras pueden necesitar
        mayores aportes para alcanzar un rendimiento óptimo.
      </p>
      <h5>Principales impactos:</h5>
      <div class="row justify-content-center">
        <div class="col-lg-8 my-lg-0 my-3">
          <AccordionRED tipo="a" clase-tarjeta="tarjeta bg7">
            <div titulo="Rendimiento desigual">
              Diferencias en el crecimiento y desarrollo de los cultivos dentro
              de una misma parcela.
            </div>
            <div titulo="Ineficiencia en el uso de insumos">
              Aplicación uniforme de fertilizantes o agua en áreas con
              necesidades variables puede resultar en desperdicio de recursos o
              deficiencias en ciertas zonas.
            </div>
            <div titulo="Incremento de costos">
              La falta de adaptación a la variabilidad puede generar costos
              adicionales en insumos y mano de obra.
            </div>
            <div titulo="Sostenibilidad comprometida">
              El manejo inadecuado de la variabilidad puede resultar en impactos
              negativos sobre el suelo y los recursos hídricos.
            </div>
          </AccordionRED>
        </div>
        <div class="col-lg-4 my-lg-0 my-3">
          <img class="img-a img-t" src="@/assets/curso/temas/82.png" alt="" />
        </div>
      </div>
      <Separador></Separador>
      <div
        id="t_4_4"
        class="titulo-segundo color-acento-contenido"
        data-aos="zoom-in-left"
      >
        <h2>4.4 Estrategias de manejo específico por sitio (MSS)</h2>
      </div>
      <div class="bg10 mb-4">
        <div class="row justify-content-center">
          <div class="col-lg-8 my-3 j1">
            <div class="p-4">
              <p class="mb-0">
                El manejo específico por sitio (MSS) es una estrategia clave
                para abordar la variabilidad espacial dentro de los sistemas
                productivos. Implica la adaptación de prácticas agrícolas a las
                condiciones específicas de cada zona dentro de una parcela,
                utilizando datos detallados para tomar decisiones más precisas.
              </p>
            </div>
          </div>
          <div class="col-lg-4">
            <img class="img-a img-t" src="@/assets/curso/temas/83.png" alt="" />
          </div>
        </div>
      </div>
      <Separador></Separador>
      <div
        id="t_4_5"
        class="titulo-segundo color-acento-contenido"
        data-aos="zoom-in-left"
      >
        <h2>4.5 Uso de tecnologías para la gestión de la variabilidad</h2>
      </div>
      <p>
        Permiten mapear la variabilidad espacial dentro de una parcela y
        analizar datos georreferenciados, como la fertilidad del suelo y la
        topografía, para diseñar estrategias de manejo específicas para cada
        zona.
      </p>
      <div class="row justify-content-center">
        <div class="col-lg-12">
          <div class="titulo-sexto color-acento-contenido">
            <h5>Tabla 4.</h5>
            <span>Tecnologías para la gestión de la variabilidad</span>
          </div>
          <div class="tabla-a color-acento-botones mb-5">
            <table>
              <caption>
                Fuente: OIT, 2024.
              </caption>
              <thead>
                <tr>
                  <th>Tecnología</th>
                  <th>Aplicación</th>
                  <th>Ventajas</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <b>Sistemas de información geográfica (SIG)</b
                    ><br /><br /><span
                      >Los SIG son herramientas fundamentales para la gestión de
                      la variabilidad espacial, permitiendo mapear y analizar
                      datos georreferenciados sobre el suelo, el clima y los
                      cultivo.</span
                    >
                  </td>
                  <td>
                    <ul class="lista-ul fa-ul">
                      <li>
                        <i class="fas fa-check-circle color1"></i
                        ><span
                          >Generación de mapas de fertilidad del suelo.</span
                        >
                      </li>
                      <li>
                        <i class="fas fa-check-circle color1"></i
                        ><span
                          >Identificación de zonas con estrés hídrico.</span
                        >
                      </li>
                      <li>
                        <i class="fas fa-check-circle color1"></i
                        ><span>Análisis de patrones de rendimiento.</span>
                      </li>
                    </ul>
                  </td>
                  <td>
                    <ul class="lista-ul fa-ul">
                      <li>
                        <i class="fas fa-check-circle color1"></i
                        ><span
                          >Visualización clara de la variabilidad dentro de una
                          parcela.</span
                        >
                      </li>
                      <li>
                        <i class="fas fa-check-circle color1"></i
                        ><span>Toma de decisiones más informada.</span>
                      </li>
                      <li>
                        <i class="fas fa-check-circle color1"></i
                        ><span
                          >Integración con otras tecnologías de monitoreo.</span
                        >
                      </li>
                    </ul>
                  </td>
                </tr>
                <tr>
                  <td>
                    <b>Drones y sensores remotos</b><br /><br /><span
                      >Los drones equipados con cámaras multiespectrales y
                      térmicas son ideales para monitorear grandes áreas
                      agrícolas con alta precisión.</span
                    >
                  </td>
                  <td>
                    <ul class="lista-ul fa-ul">
                      <li>
                        <i class="fas fa-check-circle color1"></i
                        ><span
                          >Detección temprana de plagas y enfermedades.</span
                        >
                      </li>
                      <li>
                        <i class="fas fa-check-circle color1"></i
                        ><span
                          >Monitoreo de la salud de los cultivos mediante
                          índices de vegetación como NDVI.</span
                        >
                      </li>
                      <li>
                        <i class="fas fa-check-circle color1"></i
                        ><span>Mapeo de zonas con baja productividad.</span>
                      </li>
                    </ul>
                  </td>
                  <td>
                    <ul class="lista-ul fa-ul">
                      <li>
                        <i class="fas fa-check-circle color1"></i
                        ><span>Cobertura eficiente de grandes áreas.</span>
                      </li>
                      <li>
                        <i class="fas fa-check-circle color1"></i
                        ><span
                          >Reducción del tiempo y costo de las inspecciones
                          manuales.</span
                        >
                      </li>
                      <li>
                        <i class="fas fa-check-circle color1"></i
                        ><span>Datos precisos para la gestión localizada.</span>
                      </li>
                    </ul>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <Separador> </Separador>
      <div
        id="t_4_6"
        class="titulo-segundo color-acento-contenido"
        data-aos="zoom-in-left"
      >
        <h2>4.6 Beneficios de la gestión de la variabilidad</h2>
      </div>
      <p>
        La gestión efectiva de la variabilidad espacial y temporal aporta
        múltiples beneficios, tanto económicos como ambientales:
      </p>
      <div class="row justify-content-center">
        <div class="col-lg-4 my-lg-0 my-3">
          <img class="img-a img-t" src="@/assets/curso/temas/84.png" alt="" />
        </div>
        <div class="col-lg-8 my-lg-0 my-3">
          <AccordionRED tipo="a" clase-tarjeta="tarjeta bg7">
            <div titulo="Aumento del rendimiento y calidad del producto">
              Al ajustar las prácticas de manejo a las necesidades específicas
              de cada zona, se logra un crecimiento más uniforme y un mayor
              rendimiento total.
            </div>
            <div titulo="Reducción de costos">
              Menor desperdicio de insumos y uso más eficiente de recursos como
              el agua y los fertilizantes.
            </div>
            <div titulo="Sostenibilidad ambiental">
              Al reducir la aplicación excesiva de insumos, se minimiza el
              impacto negativo sobre el suelo y los recursos hídricos.
            </div>
            <div titulo="Mejor toma de decisiones">
              El acceso a datos detallados y en tiempo real permite a los
              productores tomar decisiones más informadas y adaptativas.
            </div>
          </AccordionRED>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-lg-12">
          <div class="titulo-sexto color-acento-contenido">
            <h5>Figura 4.</h5>
            <span>Resumen gestión de variabilidad espacial y temporal</span>
          </div>
          <div class="bgfig p-4 mb-1">
            <img
              class="img-a img-t"
              src="@/assets/curso/temas/85.svg"
              alt="El diagrama se ramifica en siete aspectos principales que incluyen la importancia de la variabilidad en sistemas agropecuarios, la distinción entre variabilidad espacial y temporal, herramientas tecnológicas como SIG y drones, el uso de tecnologías para datos georreferenciados, estrategias de agricultura de precisión, y los beneficios de gestionar esta variabilidad en sistemas productivos."
            />
          </div>
          <figcaption class="mb-5">Fuente: OIT, 2024.</figcaption>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Tema4',
  data: () => ({
    // variables de vue
  }),
  mounted() {
    this.$nextTick(() => {
      this.$aosRefresh()
    })
  },
  updated() {
    this.$aosRefresh()
  },
}
</script>

<style lang="sass"></style>
